import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../../services/adminApi';
import { useAdminStore } from '../../store/adminStore';

export default function AdminLogin() {
  const navigate = useNavigate();
  const setAdminAuth = useAdminStore((s) => s.setAdminAuth);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await adminApi.post('/login', { email, password });
      setAdminAuth(res.data.admin, res.data.accessToken);
      navigate('/admin/dashboard', { replace: true });
    } catch (err: any) {
      setError(
        err.response?.data?.message ??
          err.message ??
          'Login failed'
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-white/5 border border-white/10 rounded-2xl p-8 space-y-5"
      >
        <div className="text-center mb-2">
          <h1 className="text-2xl font-bold text-white">T3 Poker Admin</h1>
          <p className="text-gray-400 text-sm mt-1">Restricted access</p>
        </div>

        <div>
          <label className="block text-xs text-gray-400 mb-1.5">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
            className="w-full px-3 py-2.5 bg-black/30 border border-white/10 rounded-lg text-white focus:outline-none focus:border-brand-cyan/60"
          />
        </div>

        <div>
          <label className="block text-xs text-gray-400 mb-1.5">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            className="w-full px-3 py-2.5 bg-black/30 border border-white/10 rounded-lg text-white focus:outline-none focus:border-brand-cyan/60"
          />
        </div>

        {error && (
          <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading || !email || !password}
          className="w-full px-4 py-2.5 bg-gradient-to-r from-brand-cyan to-brand-purple text-white font-semibold rounded-lg disabled:opacity-50 hover:opacity-90 transition active:scale-[0.98]"
        >
          {loading ? 'Signing in\u2026' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
